import React, { ReactNode } from 'react'
import 'react-datepicker/dist/react-datepicker.css'

import { AppRouter } from './AppRouter'
import { SlotPortalProvider } from './Components/Portal'
import { DimensionsProvider } from './utils/dimensions-context'
import { ThemeProvider } from './Components/ThemeSwitcher'
import { QueryClient, QueryClientProvider } from 'react-query'

// The components are already imported and have their own type definitions
// No need to redeclare them

const queryClient = new QueryClient()
// eslint-disable-next-line functional/no-class
class App_ extends React.Component<
  Record<string, never>,
  Record<string, never>
> {
  render(): JSX.Element {
    return (
      <DimensionsProvider>
        <SlotPortalProvider>
          <ThemeProvider>
            <QueryClientProvider client={queryClient}>
              <AppRouter />
            </QueryClientProvider>
          </ThemeProvider>
        </SlotPortalProvider>
      </DimensionsProvider>
    )
  }
}

export const App = App_
